import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FilePdf, CircleNotch } from "@phosphor-icons/react";

// One-click branded server-generated PDF download for any document.
export default function ExportPdfButton({ docId, label = "Download PDF" }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await api.get(`/documents/${docId}/export.pdf`, { responseType: "blob" });
      const disp = res.headers["content-disposition"] || "";
      const match = disp.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : `MODUS-${docId}.pdf`;
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Could not generate the PDF. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="download-pdf-button"
      onClick={download}
      disabled={busy}
      className="inline-flex items-center gap-2 rounded-sm border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
    >
      {busy ? <CircleNotch size={16} className="animate-spin" /> : <FilePdf size={16} />} {label}
    </button>
  );
}
